module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo03-b152258f5531216daa71c2810ad3fff0.jpg";